
import React from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetClose
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface MobileMenuProps { }

const MobileMenu: React.FC<MobileMenuProps> = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { user, signOut } = useAuth();

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <Menu className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[80%] sm:w-[350px]">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
          <SheetDescription>
            Navigate through Teenvisor
          </SheetDescription>
        </SheetHeader>
        <div className="py-4">
          {user && (
            <>
              <SheetClose asChild>
                <Link
                  to="/dashboard"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Dashboard
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/profile"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Profile
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/clubs"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Clubs
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/events"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Events
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/opportunities"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Opportunities
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/mentors"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Mentors
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Link
                  to="/pitch-playground"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  Pitch Ideas
                </Link>
              </SheetClose>
              <SheetClose asChild>
                <Button
                  variant="ghost"
                  className="flex items-center justify-start w-full py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => {
                    signOut();
                    setIsOpen(false);
                  }}
                >
                  Sign Out
                </Button>
              </SheetClose>
            </>
          )}
          {!user && (
            <>
              <SheetClose asChild>
                <Link
                  to="/auth"
                  className="flex items-center py-2 px-3 rounded-md hover:bg-accent mb-1"
                  onClick={() => setIsOpen(false)}
                >
                  <Button variant="default" className="w-full bg-gradient-to-r from-primary to-primary/80 text-white font-semibold">
                    Join Now! 🚀
                  </Button>
                </Link>
              </SheetClose>
            </>
          )}
        </div>
        <SheetClose asChild>
          <Button variant="outline">Close</Button>
        </SheetClose>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;
